import React, { useState, useEffect } from 'react';
import { Heart, Sparkles, Star, Camera } from 'lucide-react';
import { initGA, logPageView } from './analytics'

export default function PrettiestGirlApp() {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [showHearts, setShowHearts] = useState(false);
  const [sparkleAnimation, setSparkleAnimation] = useState(false);

  const sweetMessages = [
    "Tum ho... toh sab kuch hai. Bina tumhare, sab kuch adhura lagta hai. 💫",
    "Teri muskurahat meri pehchaan hai — khuda kare yeh kabhi kam na ho. 😊",
    "Har pal tumhare saath kisi film ke pyaare scene jaisa lagta hai. 🎬💖",
    "Main tumhein har din waisa chahna chahta hoon jaise aaj tumse pehli baar mila hoon. 🌹",
    "Tum meri zindagi ka wo geet ho, jo kabhi purana nahi hota. 🎵",
    "Jab tum paas hoti ho, duniya ki har cheez ruk jaati hai... sirf tum rehti ho. 🕊️",
    "Aankhon mein bas gaya hai tera chehra — ab har sapna sirf tera hai. 🌙",
    "Mujhe tumse sirf mohabbat nahi... ek zindagi chahiye, tumhare saath. 🫶",
    "Tum meri har dua mein ho, har khwaab mein ho, aur har saans mein ho. 💞",
    "Tumhara haath thaam kar chalna hai... chahe raasta aasaan ho ya mushkil. 🛤️",
    "Tere bina toh sab kuch hai, lekin sab kuch mein kuch bhi nahi. 🌧️",
    "Main tumhein sirf pyaar nahi karta... main tumhein mehsoos karta hoon, har lamha. 💓",
    "Meri har khushi ka sabab tum ho... aur main uss khushi ko kabhi khona nahi chahta. 🎁",
    "Tujh mein hi basa hai mera aashiyana... tu hai toh main hoon. 🏡❤️",
    "Pyaar ka matlab sirf tum ho — sab kuch shuru bhi tum se hota hai, aur khatam bhi. ♾️"
  ];  

  useEffect(() => {
    initGA();
    logPageView(window.location.pathname);

    const messageInterval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % sweetMessages.length);
    }, 4500);

    const heartInterval = setInterval(() => {
      setShowHearts(true);
      setTimeout(() => setShowHearts(false), 2500);
    }, 7000);

    const sparkleInterval = setInterval(() => {
      setSparkleAnimation(true);
      setTimeout(() => setSparkleAnimation(false), 1500);
    }, 4000);

    return () => {
      clearInterval(messageInterval);
      clearInterval(heartInterval);
      clearInterval(sparkleInterval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 relative overflow-hidden">
      {/* Floating Hearts Animation */}
      {showHearts && (
        <div className="absolute inset-0 pointer-events-none z-10">
          {[...Array(25)].map((_, i) => (
            <Heart
              key={i}
              className="absolute text-pink-300 animate-bounce opacity-70"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 2}s`
              }}
              size={12 + Math.random() * 20}
            />
          ))}
        </div>
      )}

      {/* Gentle Sparkle Effects */}
      <div className="absolute inset-0 pointer-events-none z-5">
        {[...Array(20)].map((_, i) => (
          <Sparkles
            key={i}
            className={`absolute text-pink-200 ${sparkleAnimation ? 'animate-pulse' : 'opacity-40'} transition-all duration-1000`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`
            }}
            size={8 + Math.random() * 12}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-20 flex flex-col items-center justify-center min-h-screen p-4 sm:p-6 lg:p-8">
        
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-pink-400 via-rose-400 to-pink-500 bg-clip-text text-transparent mb-3 sm:mb-4 leading-tight">
            The Prettiest Girl
          </h1>
          <div className="flex items-center justify-center gap-2 text-pink-400">
            <Star className="animate-pulse" size={16} />
            <span className="text-lg sm:text-xl text-gray-600 font-light">in the whole world</span>
            <Star className="animate-pulse" size={16} />
          </div>
        </div>

        {/* Photo Section */}
        <div className="relative mb-8 sm:mb-12">
          <div className="w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 rounded-full bg-gradient-to-br from-pink-200 via-rose-200 to-pink-300 flex items-center justify-center shadow-2xl border-4 sm:border-8 border-white relative overflow-hidden">
            {/* Beautiful placeholder */}
            <img 
              src="/her.jpg" 
              alt="The Prettiest Girl" 
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          
          {/* Decorative floating elements */}
          <Heart className="absolute -top-2 -right-2 sm:-top-4 sm:-right-4 text-pink-400 animate-pulse drop-shadow-sm" size={24} />
          <Heart className="absolute -bottom-2 -left-2 sm:-bottom-4 sm:-left-4 text-rose-400 animate-pulse drop-shadow-sm" size={20} />
          <Sparkles className="absolute top-6 -left-6 sm:top-8 sm:-left-8 text-pink-300 animate-spin-slow drop-shadow-sm" size={18} />
          <Sparkles className="absolute bottom-6 -right-6 sm:bottom-8 sm:-right-8 text-rose-300 animate-spin-slow drop-shadow-sm" size={16} />
        </div>

        {/* Dynamic Message */}
        <div className="text-center mb-8 sm:mb-12 w-full max-w-md px-4">
          <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-xl border border-pink-100">
            <p className="text-xl sm:text-2xl font-semibold text-gray-700 transition-all duration-1000 leading-relaxed">
              {sweetMessages[currentMessage]}
            </p>
          </div>
        </div>

        {/* Love Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 w-full max-w-sm sm:max-w-4xl mb-8 sm:mb-12 px-4">
          <div className="bg-white bg-opacity-80 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center shadow-lg border border-pink-100 transform hover:scale-105 transition-all duration-300">
            <div className="text-2xl sm:text-3xl font-bold text-pink-500 mb-1 sm:mb-2">∞</div>
            <div className="text-gray-600 font-medium text-sm sm:text-base">Love for You</div>
          </div>
          <div className="bg-white bg-opacity-80 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center shadow-lg border border-rose-100 transform hover:scale-105 transition-all duration-300">
            <div className="text-2xl sm:text-3xl font-bold text-rose-500 mb-1 sm:mb-2">100%</div>
            <div className="text-gray-600 font-medium text-sm sm:text-base">Beautiful Inside & Out</div>
          </div>
          <div className="bg-white bg-opacity-80 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center shadow-lg border border-pink-100 transform hover:scale-105 transition-all duration-300">
            <div className="text-2xl sm:text-3xl font-bold text-pink-500 mb-1 sm:mb-2">24/7</div>
            <div className="text-gray-600 font-medium text-sm sm:text-base">Thinking About You</div>
          </div>
        </div>

        {/* Additional Sweet Messages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 w-full max-w-2xl mb-8 sm:mb-12 px-4">
          {[
            "Your laugh is music to my soul 🎵",
            "You make every day brighter ☀️",
            "You're my favorite person 💕",
            "Your kindness amazes me 🌟"
          ].map((message, index) => (
            <div key={index} className="bg-pink-50 bg-opacity-80 backdrop-blur-sm rounded-xl p-3 sm:p-4 text-center shadow-md border border-pink-100 transform hover:scale-105 transition-all duration-300">
              <p className="text-gray-700 font-medium text-sm sm:text-base">{message}</p>
            </div>
          ))}
        </div>

        {/* Footer Message */}
        <div className="text-center">
          <p className="text-lg text-gray-600 mb-2">Made with 💖 just for you</p>
          <p className="text-sm text-gray-500">You deserve all the love in the world</p>
        </div>
      </div>

      {/* Custom CSS for slow spin animation */}
      <style jsx>{`
        .animate-spin-slow {
          animation: spin 8s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}